import Thread from './thread';
var CommentVM = function(data, parent_id, parent_type) {
  var self                      = this;
  self.parent_id                = ko.observable(parent_id);
  self.parent_type              = ko.observable(parent_type);
  self.last_edit_time_formatted = ko.observable('');
  self.content_with_signed_urls  = ko.observable('');
  self.allowed_to_edit          = ko.observable();

  self.id              = ko.observable(null);
  self.new_comment     = ko.observable('');
  self.time_formatted  = ko.observable('');
  self.content         = ko.observable('');
  self.vote_count      = ko.observable(0);
  self.voted           = ko.observable(false);
  self.edited          = ko.observable(false);
  self.mode            = ko.observable('form');
  self.thread_comments = ko.observableArray([]);
  self.old_content     = ko.observable();
  self.deleted         = ko.observable(false);
  self.nested_index    = ko.observable(0);

  self.vote_count_formatted = ko.computed(function() {
    return self.vote_count();
  }, self);

  self.collapse_comments = function(comment, event){
    let $target = $(event.target);
    if ($target.hasClass('collapsed')){
      $target.removeClass('collapsed');
    } else{
      $target.addClass('collapsed');
    }
    let $parent = $(event.target.parentElement);
    let $targets = $parent.find('.collapse');
    $targets.collapse('toggle');
  };

  self.time_ago_edited = ko.computed(function() {
    if(self.edited() && !self.deleted()) {
      return '(Edited ' + moment(self.updated_at()).fromNow() + ')';
    }
  });

  self.vote_up = function(comment) {
    let current_vote_count = self.vote_count();
    var type = 'up';
    if (self.voted() == 'up') {
      // neutralize vote
      self.vote_count(current_vote_count - 1);
      type = 'neutral';
    } else if (self.voted() == 'down') {
      // reverse vote
      self.vote_count(current_vote_count + 2);
    } else {
      self.vote_count(current_vote_count + 1);
    }
    self.voted(type);
    $.getJSON('/replies/' + self.id() + '/vote/' + type, {});
  };

  self.add_new_comment = function(comment) { //CommentVM(data, parent_id, parent_type)
    var comment_data;
    var thread_comment_form = _.find(self.thread_comments(), function(thread_comment){ return thread_comment.id() == null;});
    if(typeof thread_comment_form === 'undefined'){
      console.log('adding comment...');
      if(self.depth() > 4){
        comment_data = {
          forum_id: self.forum_id(),
          forum_thread_id: self.forum_thread_id(),
          depth: 5
        };

        self.thread_comments.push(new CommentVM(comment_data, self.parent_id(), 'ThreadComment'));

      } else{
        comment_data = {
          forum_id: self.forum_id(),
          forum_thread_id: self.forum_thread_id(),
          depth: comment.depth() + 1
        };

        self.thread_comments.push(new CommentVM(comment_data, self.id(), 'ThreadComment'));
      }

      Thread.scrollToElement(document.getElementById('comment_null'));
    }
    console.log(self.thread_comments());
  };

  self.cancel_new_comment = function() {
    console.log('canceling comment...');
    self.thread_comments.pop();
  };

  self.edit_comment = function() {
    self.old_content(self.content());
    var thread_comment_form = _.find(self.thread_comments(), function(thread_comment){ return thread_comment.id() == self.id();});
    if(typeof thread_comment_form === 'undefined'){
      // self.thread_comments.push(new CommentVM(null, self.id, 'ForumThread'));
      console.log('edit_comment');
      console.log(self.id());
      console.log(self);
      console.log(self.parent_id());
      self.mode('form');
      Thread.scrollToElement(document.getElementById('comment_' + self.id()));
    }
  };

  self.cancel_editing = function() {
    self.mode('show');
    self.content(self.old_content());
  };

  //Whitelist of properties that we will send to the server
  self.jsonProps = ['content', 'deleted'];

  //helper function to strip out unused properties before saving to the server
  self.cleanObjForSave = function(obj, allowedProps) {
    for (var prop in obj) {
      if (allowedProps.indexOf(prop) < 0) {
        delete obj[prop];
      }
    }
    return obj;
  };

  self.save  = function(comment, event) {
    if (!self.validate()) {
      return;
    }

    var course_id = $('#course_id').val(),
      button = event ? Ladda.create(event.target) : null,
      url,
      type,
      dataObj = {
        'thread_comment': self.cleanObjForSave(ko.toJS(self), self.jsonProps)
      };

    if (self.parent_type() == 'ForumThread') {
      var conversation_id = self.forum_id();
      var thread_id       = self.forum_thread_id();
      url                 = Kadenze.Routes.course_forum_thread_replies_path(course_id, conversation_id, thread_id);
      url                 = self.id() ? url + '/' + self.id() : url;
    } else {
      console.log('parent is thread comment');
      url                 = Kadenze.Routes.reply_replies_path(self.parent_id());
      url                 = self.id() ? url + '/' + self.id() : url;
    }

    if(self.canDeleteComment(self)) {
      type = 'DELETE';
      url = Kadenze.Routes.reply_path(self.id());
    } else if (self.id()) {
      type = 'PUT';
    } else {
      type = 'POST';
    }

    var request = new Kadenze.AjaxRequest({
      type: type,
      url: url,
      data: dataObj,
      context: self,
      timeout: 120000, //KADWEB-4455 HOTFIX 2 minute timeout on the request, production can be delayed
      beforeSend: function() {

        // Show loading indicator on the button
        if(button) {
          button.start();
        }
      }
    });

    request.done(function(data) {
      var message;

      if (data.thread_comment) {
        var parsed                    = ko.mapping.fromJSON(data.thread_comment); // JSON.parse(data.thread_comment);

        var canDestroy = (parsed.user && parsed.user.role && (parsed.user.role() === 'Admin' || parsed.user.role() === 'Instructor'));
        self.id(parsed.id());
        self.user                     = parsed.user;
        self.created_at               = parsed.created_at;
        self.time_formatted           = parsed.time_formatted();
        self.last_edit_time_formatted = parsed.last_edit_time_formatted();
        self.updated_at               = parsed.updated_at();
        self.edited                   = parsed.edited();
        self.edited                   = parsed.edited();
        self.content_with_signed_urls = parsed.content_with_signed_urls()
        self.allowed_to_destroy       = ko.observable(canDestroy);
        self.allowed_to_edit(true);
        self.mode('show');
        Kadenze.IframeUtils.decorateAll();
      }

      // Notify the parent thread VM that the comments changed
      let thread_vm = $('#ko_forum_thread_view_model').data('VM');

      if(data.deleted) {
        thread_vm.removeComment(self.id());
      }

      thread_vm.thread_comments.valueHasMutated();
      thread_vm.selected_filter.valueHasMutated();

      // Hide loading indicator on the button
      if(button) {
        button.stop();
      }

      if(data.deleted || self.deleted()) {
        message = 'Comment Deleted';
      } else {
        message = 'Comment Posted';
      }

      new Kadenze.Notice.success({
        message: message
      });
    });

    request.fail(function(data) {
      var contentElement = $('.quill-editor-institution-forum-thread-content-' + self.id()).find('.ql-editor');
      var isContentEmpty = contentElement.text() === '';
      var message;

      // Hide loading indicator on the button
      if(button) {
        button.stop();
      }

      if(isContentEmpty) {
        $('.quill-required-error').removeClass('hide');
        contentElement.addClass('ql-missing-field-error');
      }

      if(data.statusText === 'timeout') {
        // KADWEB-4455 HOTFIX Adding some messaging, when the request does timeout, the comment still posts, need to determine
        // why the default 15 second timeout is happening on production
        message = 'The request has timed out, please refresh this page to see if your comment has been added and try again.';
      } else {
        if (data.responseJSON ) {
          message = data.responseJSON.message;
        } else {
          message = data.responseText;
        }
      }

      console.log(data);
      new Kadenze.Notice.error({
        message: message
      });

      console.warn('error saving comment');
      console.log(data);
    });
  };

  self.delete_comment = function() {
    var self = this;

    Kadenze.UIUtil.confirmAction('Are you sure you want to delete this comment?',
      function() {
        self.content('<em>this comment was removed</em>');
        self.deleted(true);
        self.save(true);
      }
    );
  };

  self.canDeleteComment = function(comment) {
    if (!comment.isA(CommentVM)) {
      return false;
    }

    let noComments = comment.thread_comments().length <= 0;

    return comment.deleted() && noComments && comment.allowed_to_destroy();
  };

  self.validate = function() {
    var custom_errors = [];

    if(custom_errors.length > 0) {
      Kadenze.UIUtil.showErrors(custom_errors, $('.error-explanation').show().find('ul'));
    } else {
      $('.error-explanation').hide();
    }

    self.client_errors = ko.validation.group(self, { deep: true });
    if (self.client_errors().length === 0 && custom_errors.length === 0) {
      return true;
    } else {
      self.client_errors.showAllMessages();
      return false;
    }
  };

  self.element_id = ko.computed(function() {
    return 'comment_' + self.id();
  });

  self.userInfoTooltipParams = function (user) {
    return {
      template: 'templates/tooltip-userinfo',
      templateParams: {
        full_name: user.full_name(),
        username: user.slug(),
        email: null,
        avatar: user.avatar(),
        profile_path: user.profile_path(),
        message_path: user.message_path()
      },
      position: 'top',
      showDelay: .7
    };
  };

  self.bindData = function(data, parent_id, parent_type) {
    var mappingOptions = {};
    if (data.id) { // NEW MODEL
      mappingOptions = {
        thread_comments: {
          create: function(options) {
            return new CommentVM(options.data);
          }
        }
      };
      self.mode            = ko.observable('show');
    }
    ko.mapping.fromJS(data, mappingOptions, self);

    if (typeof self.thread_comments === 'function') {
      self.thread_comments = ko.observableArray(self.thread_comments());
    }
  };

  const __construct = function(that) {
    that.bindData(data, parent_id, parent_type);
  }(this);
};

export default CommentVM;
